import { useFormikContext } from 'formik';
import React  from 'react';
import { Col, Container, Row } from 'reactstrap';
import { FormLabel } from '../Form/FormLabel';
import PasswordFormInput from '../Form/PaswordFormInput';

const ResetPassword = ({ hide ,user }) => {
    const { values } = useFormikContext();

    return <Container>
        {!hide && <Row>
            <Col>
                <FormLabel>{values.fullName}</FormLabel>
            </Col>
            <Col>
                <FormLabel>{values.email}</FormLabel>
            </Col>
        </Row>} 
        {user ? <Row>
            <Col>
                <PasswordFormInput id='originalPassword' label='Original Password' type='password' />
            </Col>
        </Row>:null} 
        <Row>
            <Col>
                <PasswordFormInput id='password' label='New Password' type='password' />
            </Col>
        </Row>
        <Row>
            <Col>
                <PasswordFormInput id='checkPassword' label='Confirm Password' type='password' />
            </Col>
        </Row>
    </Container>;
}
export default ResetPassword; 